import { removeTrailZero } from "./numberFormatting";

export const calculateUsableBatteryCapacity = (
  usableCapacity: string | undefined,
  numberOfBatteries: string | undefined
) => {
  const usableCapacityToNumber = Number(usableCapacity);
  const numberOfBatteriesToNumber = Number(numberOfBatteries);
  return usableCapacityToNumber && numberOfBatteriesToNumber
    ? removeTrailZero(usableCapacityToNumber * numberOfBatteriesToNumber)
    : usableCapacity;
};

/**
 * Calculate Total Usable Capacity in MWh
 * Formula: (usableCapacity * numberOfBatteries) / 1000
 * @param usableCapacity - Battery capacity in kWh per battery
 * @param numberOfBatteries - Number of batteries
 * @returns Total usable capacity in MWh as a string
 */
export const calculateTotalUsableCapacityMWh = (
  usableCapacity: string | undefined,
  numberOfBatteries: string | undefined
): string => {
  const capacity = parseFloat(usableCapacity || "0");
  const numBatteries = parseFloat(numberOfBatteries || "0");
  const totalMWh = (capacity * numBatteries) / 1000;
  return totalMWh.toString();
};
